export default "__VITE_ASSET__BZSfI$ME__"